import { BankModel } from '@/entities/banks'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface BanksState {
  banks: BankModel[] | null
  loading: boolean
  error: string | null
}

const initialState: BanksState = {
  banks: null,
  loading: false,
  error: null,
}

const banksSlice = createSlice({
  name: 'banks',
  initialState,
  reducers: {
    fetchBankStart: (state) => {
      state.loading = true
      state.error = null
    },
    fetchBankSuccess: (state, action: PayloadAction<BankModel[]>) => {
      state.banks = action.payload
      state.loading = false
    },
    fetchBankFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
  },
})

export const { fetchBankStart, fetchBankSuccess, fetchBankFailure } = banksSlice.actions
export default banksSlice.reducer
